import moment from "moment";
import { useContext, useEffect, useMemo, useState } from "react";
import { AvisConstants } from "../../../data/avisConstants";
import { CreationClassGroupedRightsData } from "../../../generated/data-contracts";
import { IAxiosError, api } from "../../../utils";
import { AvisForm, AvisLoader } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { NoDataPage } from "../../shared/error/NoDataPage";
import { DelegatedRightsGroup } from "./DelegatedRightsGroup";

export function DelegatedRightsPage() {
  const { res, ctxRightsHolder } = useContext(AvisContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<IAxiosError>();
  const [delegatedRights, setDelegatedRights] =
    useState<CreationClassGroupedRightsData>({});

  useEffect(() => {
    if (!ctxRightsHolder?.rightsHolderId) return;
    setLoading(true);

    api
      .rightsHoldersGetDelegatedRights(ctxRightsHolder.rightsHolderId)
      .then((res) => setDelegatedRights(res.data))
      .catch(setError)
      .finally(() => setLoading(false));
  }, [ctxRightsHolder?.rightsHolderId]);

  const renderContent = useMemo(() => {
    if (loading) return <AvisLoader inline />;

    if (
      !delegatedRights?.groupedRights ||
      delegatedRights?.groupedRights?.length === 0
    )
      return <NoDataPage />;

    return (
      <DelegatedRightsGroup delegatedRights={delegatedRights.groupedRights} />
    );
  }, [delegatedRights, loading]);
  const updatedDateValueString = moment(delegatedRights.updateDate).format(
    AvisConstants.date_format,
  );
  return (
    <AvisForm error={error} title={res("authors_DelegatedRightsPage_Title")}>
      <AvisDescriptiveText textKey="portal_RH_DelegatedRights_1" />
      {renderContent}
      <div className={"avis-descriptive-text"}>
        {res(
          "authors_DelegatedRightsPage_label_Updated",
          updatedDateValueString,
        )}
      </div>
      <AvisDescriptiveText textKey="portal_RH_DelegatedRights_2" />
    </AvisForm>
  );
}
